/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LoanPage = lazyLoad(
  () => import('./index'),
  module => module.LoanPage
);
